var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 29,
    viewBox: "0 0 36 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0719 13.9644L1.82732 4.56232C3.28663 2.21635 5.90968 0.645996 8.86524 0.645996H27.3375C30.293 0.645996 32.8976 2.19786 34.3754 4.54383L21.1677 13.9274C19.302 15.1651 16.9006 15.1651 15.0719 13.9644ZM35.613 8.21979L23.2736 16.9756C21.6849 18.0285 19.8747 18.5455 18.0829 18.5455C16.3095 18.5455 14.5362 18.0285 12.9845 16.9941L0.589715 8.21979C0.571243 8.45993 0.552734 8.71836 0.552734 8.9585V20.0418C0.552734 24.6229 4.28412 28.3543 8.86524 28.3543H27.3375C31.9186 28.3543 35.65 24.6229 35.65 20.0418V8.9585C35.65 8.71836 35.6315 8.45993 35.613 8.21979Z",
    fill: "#C2C4CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.085cd22c4f3fec6570a0e7ef8b720de5.svg";
export { ForwardRef as ReactComponent };